import { useState } from 'react';
import { useAuth } from '../hooks/useAuth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.message || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={s.wrapper}>
      <form onSubmit={handleSubmit} style={s.card}>
        {/* Logo */}
        <div style={s.logoWrap}>
          <div style={s.logoRow}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="4" width="8" height="16" rx="2" fill="var(--accent)" />
              <rect x="12" y="8" width="5" height="12" rx="1" fill="var(--accent)" opacity="0.5" />
              <rect x="19" y="12" width="3" height="8" rx="1" fill="var(--accent)" opacity="0.3" />
            </svg>
            <span style={s.logoText}><span style={s.logoBold}>AD</span>INTEL</span>
          </div>
          <p style={s.subtitle}>Ad Intelligence Platform</p>
        </div>

        {error && <div style={s.error}>{error}</div>}

        <div style={s.field}>
          <label style={s.label}>Email</label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="seu@email.com"
            required
            style={s.input}
          />
        </div>

        <div style={s.field}>
          <label style={s.label}>Senha</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            style={s.input}
          />
        </div>

        <button type="submit" disabled={loading} style={s.button}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}

const s = {
  wrapper: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'var(--bg)',
    padding: 16,
  },
  card: {
    width: '100%',
    maxWidth: 380,
    background: 'var(--surface)',
    borderRadius: 12,
    padding: '40px 36px',
    border: '1px solid var(--border)',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  logoWrap: {
    textAlign: 'center',
    marginBottom: 8,
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
  },
  logoText: {
    fontSize: 20,
    fontWeight: 400,
    color: 'var(--text2)',
    letterSpacing: 3,
  },
  logoBold: {
    fontWeight: 800,
    color: 'var(--text)',
  },
  subtitle: {
    fontSize: 11,
    color: 'var(--text3)',
    marginTop: 8,
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  field: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: 'var(--text3)',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  input: {
    padding: '10px 14px',
    fontSize: 13,
    border: '1px solid var(--border)',
    borderRadius: 8,
    outline: 'none',
    background: 'var(--surface2)',
    color: 'var(--text)',
    fontFamily: 'inherit',
  },
  button: {
    padding: '11px 0',
    fontSize: 13,
    fontWeight: 600,
    background: 'var(--accent)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    cursor: 'pointer',
    fontFamily: 'inherit',
    marginTop: 4,
  },
  error: {
    padding: '10px 14px',
    background: 'rgba(244,63,94,0.08)',
    border: '1px solid rgba(244,63,94,0.2)',
    borderRadius: 8,
    color: 'var(--accent-r)',
    fontSize: 11,
  },
};
